import { useBotbLeaderboardContext } from "../context";
import Skeleton from "react-loading-skeleton";
import { TopSubscribe } from "./TopSubscribe";
import { useEffect, useMemo, useState } from "react";
import { DEVICE_RESOLUTION } from "../../../app-constants";

const COLORS = {
  "navigation-orange": {
    title: "text-nav-orange",
    bgBadge: "bg-nav-orange/20",
    textBadge: "text-nav-badge-orange",
  },
  "navigation-blue": {
    title: "text-nav-blue",
    bgBadge: "bg-nav-blue/20",
    textBadge: "text-nav-badge-blue",
  },
  "navigation-purple": {
    title: "text-nav-purple",
    bgBadge: "bg-nav-purple/20",
    textBadge: "text-nav-badge-purple",
  },
  "navigation-turquoise": {
    title: "text-nav-turquoise",
    bgBadge: "bg-nav-turquoise/20",
    textBadge: "text-nav-badge-turquoise",
  },
  "navigation-red": {
    title: "text-nav-red",
    bgBadge: "bg-nav-red/20",
    textBadge: "text-nav-badge-red",
  },
  "navigation-white": {
    title: "text-nav-white",
    bgBadge: "bg-nav-white/20",
    textBadge: "text-nav-badge-white",
  },
  "navigation-azure": {
    title: "text-nav-azure",
    bgBadge: "bg-nav-azure/20",
    textBadge: "text-nav-badge-azure",
  },
  "navigation-green": {
    title: "text-nav-green",
    bgBadge: "bg-nav-green/20",
    textBadge: "text-nav-badge-green",
  },
  "navigation-dark-fuchsia": {
    title: "text-nav-dark-fuchsia",
    bgBadge: "bg-nav-dark-fuchsia/20",
    textBadge: "text-nav-badge-dark-fuchsia",
  },
  "navigation-dark-blue": {
    title: "text-nav-dark-blue",
    bgBadge: "bg-nav-dark-blue/20",
    textBadge: "text-nav-badge-dark-blue",
  },
} as const;

export function EarnPoints() {
  const { activeCompetitions, activeCompetitionsLoading } = useBotbLeaderboardContext();

  const setPointsByCompetitionType = (item: any) => {
    if (item.Reference.includes("DC")) return 10;
    if (item.Reference.includes("LS")) return 2;
    if (item.Reference.includes("XC")) return 9;
    if (item.Reference.includes("HC")) return 50;
    if (
      item.Reference.includes("IW") ||
      item.Reference.includes("IA") ||
      item.Reference.includes("IB") ||
      item.Reference.includes("IC")
    )
      return 25;
    if (item.Reference.includes("EW")) return 1;
    return 1;
  };

  const onCompetitionClick = (item: any) => {
    location.href = item.PageUrl;
    return;
  };

  const [isMobile, setIsMobile] = useState(
    window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const competitionsToDisplay = useMemo(
    () =>
      (activeCompetitions || [])
        .map(item => ({
          CompetitionThumbnailPicture: item.CompetitionThumbnailPicture,
          Title: item.Title,
          NavigationColour: item.NavigationColour,
          Reference: item.Reference,
          PageUrl: item.PageUrl,
          Points: setPointsByCompetitionType(item),
        }))
        .sort((a, b) => b.Points - a.Points),
    [activeCompetitions]
  );

  return (
    <div className="max-lg:max-w-screen-sm w-full max-lg:mx-auto mx-auto rounded-lg px-3 lg:px-10 py-6 lg:pt-5 lg:pb-11 font-jost lg:bg-white lg:rounded-2xl">
      {isMobile && <TopSubscribe />}

      <div className={"flex flex-col gap-2 items-center"}>
        {!activeCompetitionsLoading ? (
          competitionsToDisplay &&
          competitionsToDisplay.map((item: any) => {
            return (
              <>
                <div className={"flex items-center w-full px-2 lg:px-0 py-3"}>
                  <div className={"mr-3 rounded"}>
                    <img
                      src={item.CompetitionThumbnailPicture}
                      alt={"Placeholder"}
                      width={48}
                      height={48}
                      className="object-cover size-11 rounded lg:size-14"
                    />
                  </div>
                  <div>
                    <div
                      className={`text-sm lg:text-base leading-5 lg:leading-5.5 font-medium mb-1 lg:mb-2 ${COLORS[item.NavigationColour as keyof typeof COLORS]?.title}`}>
                      {item.Title}
                    </div>
                    <div
                      className={
                        "text-center text-xs font-medium leading-4 text-gray-5 rounded-2xl bg-gray-6 px-1.5 py-0.5 w-fit lg:text-sm lg:leading-5"
                      }>
                      <strong className={"text-dark-1"}>+{item.Points} points</strong> per ticket
                    </div>
                    {item.Reference.includes("DC") ? (
                      <div className="text-xs text-gray-5">+ extra points for add-ons</div>
                    ) : null}
                  </div>
                  <div
                    onClick={() => onCompetitionClick(item)}
                    className={
                      "cursor-pointer uppercase bg-[#EEEEEF] ml-auto text-center px-2.5 py-1 rounded-lg text-nav-azure font-jost text-xs font-medium leading-normal min-h-8 lg:min-h-10 lg:min-w-20 flex-center lg:text-sm lg:leading-5"
                    }>
                    Enter
                  </div>
                </div>
                <div className={"w-full h-px bg-black/8 last:hidden"} />
              </>
            );
          })
        ) : (
          <Skeleton highlightColor="#fff" count={1} inline height={300} containerClassName={"grid grid-cols-1"} />
        )}
      </div>
    </div>
  );
}
